/**
 * AI Filter Menu with custom checkbox
 */

import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import {
  Button,
  Checkbox,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuItemOption,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { jobPayloadState, savedJobPayloadState } from "_state/atoms/AppAtoms";

import _ from "lodash";
import { useGetScoresQuery } from "queries/Jobs";
import { FC, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { sortObject } from "utils/jobs";
import { SecondaryButton } from "../HJSButton";

// const sectorsWithScores: readonly string[] = [
//   "90 - Warehouse",
//   "80 - Healthcare",
//   "70 - Sales Agent",
//   "60 - Cashier",
// ];

interface IAiScoreMenu {
  field: string;
  isChecked: boolean;
}

const AIMenu: FC<{ index?: number }> = ({ index }) => {
  const location = useLocation();
  const isJobSearch = location.pathname === "/jobs/search";

  const { data: scores }: any = useGetScoresQuery();

  const [payload, setPayload] = useRecoilState(jobPayloadState);
  const [savedJobPayload, setSavedJobPayload] =
    useRecoilState(savedJobPayloadState);

  const [values, setValues] = useState<string[]>([]);
  const [checked, setChecked] = useState<boolean[]>([]);

  const getPayload = isJobSearch ? payload : savedJobPayload;
  const setUpdatePayload = isJobSearch ? setPayload : setSavedJobPayload;

  useEffect(() => {
    if (scores?.aiScore as boolean) {
      setChecked(new Array(Object.keys(scores?.aiScore).length)?.fill(false));
    }
  }, [scores]);

  const updateState = (): void => {
    setValues([...(getPayload?.aiScore ?? [])]);
    const tempArr = new Array(Object.keys(scores?.aiScore ?? {}).length)?.fill(
      false
    );

    getPayload?.aiScore?.forEach((el, idx) => {
      Object.keys(sortObject(scores?.aiScore ?? {})).forEach(
        (key: any, idx: number) => {
          key === el && (tempArr[idx] = true);
        }
      );
    });
    setChecked([...tempArr]);
  };

  // resetting state to the default values present in global store
  useEffect(() => {
    updateState();
  }, [getPayload?.aiScore]);

  const menuRef = useRef();
  return (
    <Menu
      matchWidth={true}
      closeOnSelect={false}
      closeOnBlur={true}
      // isOpen={isOpen}
      onClose={() => updateState()}
    >
      {({ isOpen, onClose }) => (
        <>
          <MenuButton
            as={SecondaryButton}
            fontSize={{ base: 14, md: 16 }}
            borderLeft="2px solid white"
            borderRadius="initial"
            rightIcon={
              isOpen ? (
                <ChevronUpIcon className="fill-white" />
              ) : (
                <ChevronDownIcon className="fill-white" />
              )
            }
            width={48}
            maxHeight="1.5rem"
          >
            <Text color="white">AI Score</Text>
          </MenuButton>

          <MenuList
            backgroundColor="teal.600 !important"
            color="white"
            py={4}
            border="none"
            minW="initial"
          >
            {Object.keys(sortObject(scores?.aiScore ?? {}))?.map(
              (key: string, idx: number) => (
                <MenuItem
                  key={key}
                  backgroundColor="teal.600 !important"
                  fontSize={{ base: 14, md: 16 }}
                  fontWeight="semibold"
                  _hover={{ backgroundColor: "hjsSecondaryHover !important" }}
                  // _focus={{ backgroundColor: "hjsSecondaryHover" }}
                  onClick={() => {
                    if (!checked[idx]) {
                      setValues((prev: any) => [...prev, key]);
                      setChecked((prev: any) => {
                        const next = [...prev];
                        next[idx] = true;
                        return next;
                      });
                    } else {
                      setValues((prev: string[]) =>
                        prev.filter((v) => v !== key)
                      );
                      setChecked((prev) => {
                        const next = [...prev];
                        next[idx] = false;
                        return next;
                      });
                    }
                  }}
                >
                  {/* <MenuItemOption /> */}
                  <Checkbox
                    className="ai-checkbox"
                    colorScheme="white"
                    isChecked={checked[idx]}
                    pointerEvents="none"
                  >
                    <Text
                      fontSize={{ base: 14, md: 16 }}
                      fontWeight="600"
                      color="white"
                    >
                      {`${scores?.aiScore?.[key] as string} - ${
                        key === "Healthcare" ? "Orderly/Personal Care" : key
                      }`}
                    </Text>
                  </Checkbox>
                </MenuItem>
              )
            )}
            <Flex justifyContent="center">
              <Button
                bgColor="transparent !important"
                border="2px solid white"
                color="white"
                mt={6}
                onClick={() => {
                  setUpdatePayload((prev: any) => ({
                    ...prev,
                    aiScore: values,
                    page: 1,
                  }));
                  onClose();
                }}
                className="hover:opacity-90"
              >
                Filter
              </Button>
            </Flex>
          </MenuList>
        </>
      )}
    </Menu>
  );
};

export default AIMenu;
